module.exports = __webpack_public_path__ + "static/media/Icon-PDF-member.4b94b0b1.png";